import React from "react";
import { Button } from "reactstrap";
import "./invalidWorkspace.css"

export default function AuthErrorMessage(props) {
  return (
    <div class="invalid_message_div">
      <div class="invalid_message_card">
        <img
          class="invalid_message_card_img"
          src="https://img.freepik.com/free-vector/computer-trouble-shooting-concept-illustration_114360-7376.jpg"
        />

        <h4 class="invalid_message_card_text">
          Error occured while authenticating.
        </h4>

        <div  className="mt-4 text-center">
               <Button color="primary" onClick={()=>{ props.history.push("/home/stories") }}> Go Home  </Button>
            </div>
      </div>
    </div>
  );
}
